import React, { useCallback } from 'react';
import { useAuth } from '../../../../authContext';
import { useSecurity } from '../../../../SecurityContext';
import discordAvatarDefault from '../../../../medias/avatar_default.png';
import MemberDashboardGrid from './dashboard/MemberDashboardGrid';
import MobileWebAppPromoModal from './components/MobileWebAppPromoModal';
import { displayMoniker } from './dashboard/dashboardUtils';
import usePersonalHubDashboardProfile from './hooks/usePersonalHubDashboardProfile';
import useMobileWebAppPromo from './hooks/useMobileWebAppPromo';

export default function PersonalHubDashboardSection({ isActive }) {
  const { isLoggedIn, userId } = useAuth();
  const { isViewAsActive, viewAsUserId } = useSecurity();

  const {
    player,
    loading,
    shellVisible: dashboardShellVisible,
    error,
    missingHandle,
    dashboardHandleId,
    dashboardClusterScope,
    patchPlayer,
  } = usePersonalHubDashboardProfile();

  const onRingColorSaved = useCallback((color) => {
    patchPlayer({ dashboardHeroRingColor: color });
  }, [patchPlayer]);

  const onDiscordAvatarError = useCallback((e) => {
    const img = e?.currentTarget;
    if (!img) return;
    img.onerror = null;
    img.src = discordAvatarDefault;
  }, []);

  const moniker = displayMoniker(player);

  const promoEnabled = Boolean(
    isActive && isLoggedIn && !isViewAsActive && dashboardShellVisible
  );
  const { visible: showMobilePromo, dismiss: dismissMobilePromo } = useMobileWebAppPromo({
    enabled: promoEnabled,
  });

  const noHandleMessage = isViewAsActive
    ? 'This member has no RSI handle linked to their account.'
    : 'No RSI handle linked to this account.';

  return (
    <div
      className={[
        'personal-hub-section',
        showMobilePromo ? 'personal-hub-section--promo-host' : '',
        !isActive ? 'personal-hub-section--inactive' : '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {dashboardShellVisible ? (
        <MemberDashboardGrid
          userId={userId}
          isViewAsActive={isViewAsActive}
          viewAsUserId={viewAsUserId}
          isLoggedIn={isLoggedIn}
          dashboardHandleId={dashboardHandleId}
          dashboardClusterScope={dashboardClusterScope}
          player={player}
          loading={loading && !dashboardShellVisible}
          shellVisible={dashboardShellVisible}
          moniker={moniker}
          onDiscordAvatarError={onDiscordAvatarError}
          onRingColorSaved={onRingColorSaved}
        />
      ) : null}

      {loading && !dashboardShellVisible ? (
        <p className="member-dashboard__state">Loading…</p>
      ) : null}

      {missingHandle && isLoggedIn ? (
        <p className="member-dashboard__state">{noHandleMessage}</p>
      ) : null}

      {error ? (
        <p className="member-dashboard__state member-dashboard__state--error">
          {error}
        </p>
      ) : null}

      <MobileWebAppPromoModal
        isOpen={showMobilePromo}
        onDismiss={dismissMobilePromo}
      />
    </div>
  );
}
